<template>
  <div>
    <div class="mb-4">
      <Link class="group flex items-center py-3" href="/">
        <!-- <icon name="dashboard" class="mr-2 w-4 h-4" :class="isUrl('') ? 'fill-white' : 'fill-indigo-400 group-hover:fill-white'" /> -->
        <div :class="isUrl('') ? 'text-white' : 'text-indigo-300 group-hover:text-white'">Nástěnka</div>
      </Link>
    </div>
    <div v-if="$page.props.auth.user.owner !== false" class="mb-4">
      <Link class="group flex items-center py-3" href="/components">
        <!-- <icon name="office" class="mr-2 w-4 h-4" :class="isUrl('components') ? 'fill-white' : 'fill-indigo-400 group-hover:fill-white'" /> -->
        <div :class="isUrl('components') ? 'text-white' : 'text-indigo-300 group-hover:text-white'">Komponenty</div>
      </Link>
    </div>
    <div v-if="$page.props.auth.user.owner !== false" class="mb-4">
      <Link class="group flex items-center py-3" href="/sets">
        <!-- <icon name="office" class="mr-2 w-4 h-4" :class="isUrl('sets') ? 'fill-white' : 'fill-indigo-400 group-hover:fill-white'" /> -->
        <div :class="isUrl('sets') ? 'text-white' : 'text-indigo-300 group-hover:text-white'">Sety</div>
      </Link>
    </div>
    <div class="mb-4">
      <Link class="group flex items-center py-3" href="/calculations/create">
        <!-- <icon name="office" class="mr-2 w-4 h-4" :class="isUrl('calculations/create') ? 'fill-white' : 'fill-indigo-400 group-hover:fill-white'" /> -->
        <div :class="isUrl('calculations/create') ? 'text-white' : 'text-indigo-300 group-hover:text-white'">Kalkulace RD</div>
      </Link>
    </div>
    <div class="mb-4">
      <Link class="group flex items-center py-3" href="/calculations-light/create">
        <div :class="isUrl('calculations-light/create') ? 'text-white' : 'text-indigo-300 group-hover:text-white'">Ohřev vody</div>
      </Link>
    </div>
    <div v-if="$page.props.auth.user.owner !== false" class="mb-4">
      <Link class="group flex items-center py-3" href="/generated-calculations">
        <!-- <icon name="office" class="mr-2 w-4 h-4" :class="isUrl('sets') ? 'fill-white' : 'fill-indigo-400 group-hover:fill-white'" /> -->
        <div :class="isUrl('generated-calculations') ? 'text-white' : 'text-indigo-300 group-hover:text-white'">Generované kalkulace</div>
      </Link>
    </div>
  </div>
</template>

<script>
import { Link } from '@inertiajs/inertia-vue3'
import Icon from '@/Shared/Icon'

export default {
  components: {
    Icon,
    Link,
  },
  methods: {
    isUrl(...urls) {
      let currentUrl = this.$page.url.substr(1)
      if (urls[0] === '') {
        return currentUrl === ''
      }
      return urls.filter((url) => currentUrl.startsWith(url)).length
      //return urls.filter((url) => currentUrl === url).length > 0
    },
  },
}
</script>
